module.exports = __webpack_public_path__ + "img/resource-henkel.43adfa1b.jpg";